export default __webpack_public_path__ + "static/media/header_logo.cf25dbc2.svg";